import types from '../actions/types';
import produce from 'immer';
import _findIndex from 'lodash/findIndex';

const initialState = {
  phase: 1,
  faceImage: null,
  maskImage: null,
  mode: 'source-over', // 'destination-out',
  // lines: [],
  // lineCount: 0,
  strokeWidth: 10,
  cropped: false,
  cropData: {
    unit: '%', // default, can be 'px' or '%'
    x: 30,
    y: 30,
    width: 40,
    height: 40
  },
  blob: null,
  croppedImage: null,
  finalImage: null,
  extraItems: [
  ],
  layouts: [
    {
      name: 'シンプル',
      image: 'card-p-1.png',
      objects: [
        {
          id: 'company',
          label: '会社名',
          x: 0.07,
          y: 400 / 970,
          fontSize: 33,
          sample: '長屋印刷株式会社'
        },
        {
          id: 'division1',
          label: '部署名',
          x: 0.07,
          y: 443/ 970,
          fontSize: 28,
          sample: '営業部'
        },
        {
          id: 'title',
          label: '役職名',
          x: 0.07,
          y: 506 / 970,
          fontSize: 28,
          sample: '代表取締役'
        },
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 544 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 592 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
        {
          id: 'zipcode',
          label: '郵便番号',
          x: 0.07,
          y: 737 / 970,
          fontSize: 28,
          sample: '〒999-9999'
        },
        {
          id: 'address1',
          label: '住所',
          x: 0.07,
          y: 774 / 970,
          fontSize: 28,
          sample: '愛知県名古屋市東区泉3-30-23'
        },
        {
          id: 'tel1',
          label: '電話番号',
          x: 0.07,
          y: 812 / 970,
          fontSize: 28,
          sample: 'TEL 999-999-9999'
        },
        {
          id: 'email',
          label: 'メールアドレス',
          x: 0.07,
          y: 850 / 970,
          fontSize: 28,
          sample: 'info@t-meishi-project.com'
        }
      ]
    },
    {
      name: 'シンプル',
      image: 'card-p-2.png',
      objects: [
        {
          id: 'company',
          label: '会社名',
          x: 0.07,
          y: 400 / 970,
          fontSize: 33,
          sample: '長屋印刷株式会社'
        },
        {
          id: 'division1',
          label: '部署名',
          x: 0.07,
          y: 443/ 970,
          fontSize: 28,
          sample: '営業部'
        },
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 518 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 567 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
        {
          id: 'zipcode',
          label: '郵便番号',
          x: 0.07,
          y: 654 / 970,
          fontSize: 25,
          sample: '〒999-9999'
        },
        {
          id: 'address1',
          label: '住所',
          x: 0.07,
          y: 691 / 970,
          fontSize: 25,
          sample: '愛知県名古屋市東区泉3-30-23'
        },
        {
          id: 'address2',
          label: '住所 (2行目)',
          x: 0.07,
          y: 728 / 970,
          fontSize: 25,
          sample: 'ABCビルディング1F'
        },
        {
          id: 'tel1',
          label: '電話番号1',
          x: 0.07,
          y: 769 / 970,
          fontSize: 25,
          sample: 'TEL: 999-999-9999'
        },
        {
          id: 'tel2',
          label: '電話番号2',
          x: 0.07,
          y: 802 / 970,
          fontSize: 25,
          sample: 'TEL: 000-000-0000'
        },
        {
          id: 'fax',
          label: 'FAX',
          x: 0.07,
          y: 835 / 970,
          fontSize: 25,
          sample: 'FAX: 123-456-7890'
        },
        {
          id: 'email',
          label: 'メールアドレス',
          x: 0.07,
          y: 870 / 970,
          fontSize: 25,
          sample: 'info@t-meishi-project.com'
        }
      ]
    },
    {
      name: 'シンプル',
      image: 'card-p-3.png',
      objects: [
        {
          id: 'title',
          label: '役職名',
          x: 0.07,
          y: 384 / 970,
          fontSize: 28,
          sample: '代表取締役'
        },
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 422 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 470 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
        {
          id: 'company',
          label: '会社名',
          x: 0.07,
          y: 588 / 970,
          fontSize: 29,
          sample: '長屋印刷株式会社'
        },
        {
          id: 'division1',
          label: '部署名1',
          x: 0.07,
          y: 631 / 970,
          fontSize: 25,
          sample: '営業部'
        },

        {
          id: 'zipcode',
          label: '郵便番号',
          x: 0.07,
          y: 675 / 970,
          fontSize: 25,
          sample: '〒999-9999'
        },
        {
          id: 'address1',
          label: '住所',
          x: 0.07,
          y: 712 / 970,
          fontSize: 25,
          sample: '愛知県名古屋市東区泉3-30-23'
        },
        {
          id: 'address2',
          label: '住所 (2行目)',
          x: 0.07,
          y: 749 / 970,
          fontSize: 25,
          sample: 'ABCビルディング1F'
        },
        {
          id: 'tel1',
          label: '電話番号1',
          x: 0.07,
          y: 790 / 970,
          fontSize: 25,
          sample: 'TEL: 999-999-9999'
        },
        {
          id: 'tel2',
          label: '電話番号2',
          x: 0.07,
          y: 823 / 970,
          fontSize: 25,
          sample: 'TEL: 000-000-0000'
        },
        {
          id: 'fax',
          label: 'FAX',
          x: 0.07,
          y: 856 / 970,
          fontSize: 25,
          sample: 'FAX: 123-456-7890'
        },
        {
          id: 'email',
          label: 'メールアドレス',
          x: 0.07,
          y: 891 / 970,
          fontSize: 25,
          sample: 'info@t-meishi-project.com'
        }
      ]
    },
    {
      name: 'シンプル',
      image: 'card-p-4.png',
      objects: [
        {
          id: 'title',
          label: '役職名',
          x: 0.07,
          y: 384 / 970,
          fontSize: 28,
          sample: '代表取締役'
        },
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 422 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 470 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
        {
          id: 'company',
          label: '会社名',
          x: 0.07,
          y: 553 / 970,
          fontSize: 29,
          sample: '長屋印刷株式会社'
        },
        {
          id: 'division1',
          label: '部署名1',
          x: 0.07,
          y: 596 / 970,
          fontSize: 25,
          sample: '営業部'
        },
        {
          id: 'division2',
          label: '部署名2',
          x: 0.07,
          y: 628 /  970,
          fontSize: 25,
          sample: '総務課'
        },
        {
          id: 'zipcode',
          label: '郵便番号',
          x: 0.07,
          y: 675 / 970,
          fontSize: 25,
          sample: '〒999-9999'
        },
        {
          id: 'address1',
          label: '住所',
          x: 0.07,
          y: 712 / 970,
          fontSize: 25,
          sample: '愛知県名古屋市東区泉3-30-23'
        },
        {
          id: 'address2',
          label: '住所 (2行目)',
          x: 0.07,
          y: 749 / 970,
          fontSize: 25,
          sample: 'ABCビルディング1F'
        },
        {
          id: 'tel1',
          label: '電話番号1',
          x: 0.07,
          y: 790 / 970,
          fontSize: 25,
          sample: 'TEL: 999-999-9999'
        },
        {
          id: 'tel2',
          label: '電話番号2',
          x: 0.07,
          y: 823 / 970,
          fontSize: 25,
          sample: 'TEL: 000-000-0000'
        },
        {
          id: 'fax',
          label: 'FAX',
          x: 0.07,
          y: 856 / 970,
          fontSize: 25,
          sample: 'FAX: 123-456-7890'
        },
        {
          id: 'email',
          label: 'メールアドレス',
          x: 0.07,
          y: 891 / 970,
          fontSize: 25,
          sample: 'info@t-meishi-project.com'
        }
      ]
    }
  ],
  textValues: {},
  textFonts: {},
  textColors: {},
  currentLayout: 0,
  tour: [
    true,
    true,
    true,
    true,
    true,
    true,
    true
  ],
  amount: 20
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FACE_SET_IMAGE:
      return produce(state, draftState => {
        let scale = 1.0;
        if (action.payload.object.width > 1000) {
          scale = 1000 / action.payload.object.width;
        }
        if (action.payload.object.height > 1000) {
          scale = Math.min(scale, 1000 / action.payload.object.height);
        }

        action.payload.object.props = {
          scaleX: scale,
          scaleY: scale,
          x: 0,
          y: 0,
          width: action.payload.object.width,
          height: action.payload.object.height,
        }

        draftState.faceImage = action.payload.object;
      });
    // case types.FACE_ADD_LINE:
    //   return produce(state, draftState => {
    //     draftState.lines.push(action.payload.line);
    //   });
    // case types.FACE_UPDATE_LINES:
    //   return produce(state, draftState => {
    //     let lastLine = state.lines[state.lines.length - 1];
    //     // add point
    //     lastLine.points = lastLine.points.concat([action.payload.points[0], action.payload.points[1]]);
    //
    //     // replace last
    //     draftState.lines.splice(draftState.lines.length - 1, 1, lastLine);
    //     draftState.lineCount++;
    //   });
    case types.FACE_SET_STROKE_WIDTH:
      return produce(state, draftState => {
        draftState.strokeWidth = action.payload.size;
        draftState.mode = action.payload.mode;
      });
    case types.FACE_SET_CROPPED_IMAGE:
      return produce(state, draftState => {
        draftState.cropped = true;
        draftState.blob = action.payload.blob;
        draftState.croppedImage = {
          src: action.payload.src,
          width: action.payload.width,
          height: action.payload.height
        }
      });
    case types.FACE_SET_FINAL_IMAGE:
      return produce(state, draftState => {
        draftState.finalImage = action.payload.image;
      });
    case types.FACE_MOVE_FINAL_IMAGE:
      return produce(state, draftState => {
        draftState.finalImage = {
          ...draftState.finalImage,
          ...action.payload
        };
      });
    case types.FACE_SET_PHASE:
      return produce(state, draftState => {
        draftState.phase = action.payload.phase;
      });
    case types.FACE_REMOVE_CROPPED_IMAGE:
      return produce(state, draftState => {
        draftState.cropped = false;
        draftState.blob = null;
        draftState.croppedImage = null;
      });
    case types.FACE_REMOVE_FINAL_IMAGE:
      return produce(state, draftState => {
        draftState.finalImage = null;
      });
    case types.FACE_LOAD_OBJECTS:
      return produce(state, draftState => {
        draftState.phase = 3;
        draftState.extraItems = [];
      });
    case types.CLOSE_TOUR:
      return produce(state, draftState => {
        draftState.tour[action.payload.index] = false;
      });
    case types.FACE_SET_CROP_DATA:
      return produce(state, draftState => {
        draftState.cropData = action.payload.crop;
      });
    case types.SET_TEXT_LAYOUT:
      return produce(state, draftState => {
        draftState.currentLayout = action.payload.index;
      });
    case types.SET_TEXT_VALUE:
      return produce(state, draftState => {
        draftState.textValues[action.payload.key] = action.payload.value;
      });
    case types.FACE_SET_TEXT_FONT:
      return produce(state, draftState => {
        draftState.textFonts[action.payload.key] = action.payload.font;
      });
    case types.FACE_SET_TEXT_COLOR:
      return produce(state, draftState => {
        draftState.textColors[action.payload.key] = action.payload.color;
      });
    case types.FACE_ADD_EXTRA_ITEM:
      return produce(state, draftState => {
        switch (action.payload.type) {
          case 'image':
            draftState.extraItems.push({
              id: action.payload.id,
              type: action.payload.type,
              src: null,
              props: {

              }
            })
            break;
          default:
            draftState.extraItems.push({
              id: action.payload.id,
              type: action.payload.type,
              font: {label: '源ノ角ゴシック', value: 'sourcehansansr', bold: 'sourcehansansb', fontplus: false, lang: 'ja'},
              props: {
                text: 'テキストを入力してください',
                fill: '#000000',
                fontFamily: 'sourcehansansr'
              }
            })
            break;
        }
      });
    case types.SET_EXTRA_TEXT_VALUE:
      return produce(state, draftState => {
        const index = _findIndex(state.extraItems, (item) => {
          return item.id === action.payload.id;
        })

        draftState.extraItems[index].props.text = action.payload.value;
      });
    case types.SET_EXTRA_TEXT_FONT:
      return produce(state, draftState => {
        const index = _findIndex(state.extraItems, (item) => {
          return item.id === action.payload.id;
        })

        draftState.extraItems[index].font = action.payload.font;
      });
    case types.SET_EXTRA_TEXT_COLOR:
      return produce(state, draftState => {
        const index = _findIndex(state.extraItems, (item) => {
          return item.id === action.payload.id;
        })

        draftState.extraItems[index].props.fill = action.payload.color;
      });
    case types.FACE_SET_TEXT_SIZE:
      return produce(state, draftState => {
        const index = _findIndex(draftState.layouts[state.currentLayout]['objects'], (o) => {
          return o.id === action.payload.key;
        });
        draftState.layouts[state.currentLayout]['objects'][index]['fontSize'] = action.payload.size;
      });
    case types.SET_EXTRA_TEXT_SIZE:
      return produce(state, draftState => {
        const index = _findIndex(state.extraItems, (item) => {
          return item.id === action.payload.id;
        })

        draftState.extraItems[index].props.fontSize = action.payload.size;
      });
    case types.SET_MEISHI_AMOUNT:
      return produce(state, draftState => {
        draftState.amount = action.payload.amount;
      });
    case types.FACE_SET_MASK_IMAGE:
      return produce(state, draftState => {
        draftState.maskImage = action.payload.data;
      });
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/meishiReducer.js